import React, { useContext, useEffect, useRef } from "react";
import { AuthContext } from "../../../context/authContext";
import { IAuthContext } from "../../../types/auth";
import ApplicationFallback from "../../../components/applicationFallback/ApplicationFallback";

const Logout : React.FC = () => {
    const { logout } = useContext(AuthContext) as IAuthContext;

    const canGo = useRef(true);
    useEffect(() => {
        if(canGo.current === true) {
            canGo.current = false;
            logout();
        }
    }, []);

    return(
        <ApplicationFallback />
    )
}

export default Logout;